import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { realTimeScoring } from '../../dbActions/realtimeScoring';
import { matchCalcs } from '../../helpers/match';
import { ammendMatchesAndTeams, getMatches_groupInfo } from './reducerHelpers/seasonSportsData';
import { sportsHelpers } from './reducerHelpers/sportsHelpers';

export const _matchSeasonalCollection = 'matches_seasonal'
export const _resultsSeasonalCollection = 'results_seasonal'

const _getScoresFromScores = true

export const dataItems_sportsSeasonRealtime = {
  seasonMatches: { renderAs: 'matches', collectionName: _matchSeasonalCollection, ignoreCache: true, sportPropName: 'matchInfo_seasonal', collectionSubs: ['matches', 'playoffMatches', 'playoffMatches_backup', 'scores', 'playoffScores'], subItemKey: '_matchCollectionKey' },
}

export const dataItems_matches = {
  matches_currentSeason: {
    combineSubs: true,
    renderAs: 'matches',
    collectionName: _matchSeasonalCollection,
    ignoreCache: true,
    sportPropName: 'matches_seasonal',
    collectionSubs: ['matches'],
    subItemKey: '_matchCollectionKey'
  },
}

export const dataItems_sportsSeason_create = {
  matches_seasonal: dataItems_matches.matches_currentSeason,
  seasonals: { collectionName: 'seasonals', sportPropName: 'seasonals', noListen: true, collectionSubs: ['matches'], combineSubs: true, },
  teams_seasonal: { collectionName: 'teams_seasonal', sportPropName: 'teams_seasonal', collectionDocField: 'teams', noListen: true, ignoreCache: true },
}

export const dataItems_sportsSeason_seasonals = {
  seasonals: { collectionName: 'seasonals', sportPropName: 'seasonals', noListen: true },
}

export const sportsDbCollections = {
  seasonal: {
    allStartNominations: 'allStartNominations',
    allStarTeams: 'allStarTeams',
    districts: 'districts',
    globals: 'globals',
    googleLinks: 'googleLinks',
    history: 'history',
    matches: 'matches',
    playoffs: 'playoffs',
    rankings: 'rankings',
    rosters: 'rosters',
    scheduleDates: 'rosters',
    schools: 'rosters',
    seasonals: 'seasonals',
    teams: 'teams',
  },
  normal: {
    athletes: 'athletes',
    districts: 'districts',
    globals: 'globals',
    organizations: 'organizations',
    schools: 'schools',
    teams: 'teams',
  }
}

export const matchModifyTypes = {
  addConsolationMatch: 'addConsolationMatch',
  addToHistory: 'addToHistory',
  cancelMatch: 'cancelMatch',
  confirmMatchDate: 'confirmMatchDate',
  deleteMatch: 'deleteMatch',
  postponeMatch: 'postponeMatch',
  removeResults: 'removeResults',
  resetByeMatch: 'resetByeMatch',
  updatePendingMatch: 'updatePendingMatch',
  updatePrePendingMatch: 'updatePrePendingMatch',
}

export const matchEditTypes = {
  updateFullMatchDetails: 'updateFullMatchDetails',
  updateMatchDetails: 'updateMatchDetails',
}

export const matchExternalTypes = {
  openDatabase: 'openDatabase',
  updateGsScore: 'updateGsScore',
  updateMatchListResultsFromGs: 'updateMatchListResultsFromGs',
}

export const matchUpdateTypes = {
  editFullMatchDetails: 'editFullMatchDetails',
  editMatchDetails: 'editMatchDetails',
  // updateMatchDayMatch: 'updateMatchDayMatch',
  // updateResults: 'updateResults',
  // updateScore: 'updateScore',
  updateVideoUrl: 'updateVideoUrl',
}

export const gameScoringTypes = {
  half: 'half',
  quarter: 'quarter',
  match: 'match',
  matchPoints: 'matchPoints',
  inning: 'innning',
}

export const sectionSortingTypes = {
  sectionWinningPercentage: 'sectionWinningPercentage',
  points: 'points',
}

export const sportsShowTypes = {
  allSports: 'allSports',
  appUserCount: 'appUserCount',
  compareBoth: 'compareBoth',
  compareCommon: 'compareCommon',
  compareSections: 'compareSections', // GOOD
  compareTeams: 'compareTeams',// GOOD
  showGrid: 'showGrid',
  createAllPlayoffMatches: 'createAllPlayoffMatches',
  createPlayoffMatches: 'createPlayoffMatches',
  createPlayoff: 'createPlayoff',
  fullStandings: 'fullStandings',
  matchLookup: 'matchLookup',
  news: 'news',
  favorites: 'favorites',
  matchesRemaining: 'matchesRemaining',
  matchLocation: 'matchLocation',
  matchResults: 'matchResults', // GOOD
  pastSeasons: 'pastSeasons',
  playoffPicture: 'playoffPicture',
  realtimeMatch: 'realtimeMatch',
  teamLookup: 'teamLookup',
  teamRosters: 'teamRosters',
  updateMatch: 'updateMatch',
  updateMatchDetails: 'updateMatchDetails',
  updateResults: 'updateResults',
  updateMatchDayResults: 'updateMatchDayResults',
  modifyTeamAccess: 'modifyTeamAccess',
  modifyTeamSchedule: 'modifyTeamSchedule',
  modifyTeamRoster: 'modifyTeamRoster',
  modifyTeamStaff: 'modifyTeamStaff',
  modifyTeamLinks: 'modifyTeamLinks',
  viewSchedules: 'viewSchedules', // GOOD
  viewSectionGrids: 'viewSectionGrids',
}

export const _sportsSeasonTimestampTypes = {
  sportInfo: 'sportInfo',
  sportResults: 'sportResults',
  realtimeResults: 'realtimeResults',
}

const rts = {
  // handle_testSeason: 'handle_testSeason',
  handleAmmend_mediaMatches: 'handleAmmend_mediaMatches',
  handleAmmend_playoffQualifyCounts: 'handleAmmend_playoffQualifyCounts',
  // handleAmmend_seasonMatchesFromDbResults: 'handleAmmend_seasonMatchesFromDbResults',
  handleAmmend_sportCompares: 'handleAmmend_sportCompares',
  handleAmmend_teamsAccess: 'handleAmmend_teamsAccess',
  handleDataResults_parentKeyCollections: 'handleDataResults_parentKeyCollections',
  handleFilter_sports: 'handleFilter_sports',
  handleResponse_updateMatch: 'handleResponse_updateMatch',
  handleSet_accessTeams: 'handleSet_accessTeams',
  handleSet_currentHistory: 'handleSet_currentHistory',
  handleSet_databaseCallback: 'handleSet_databaseCallback',
  handleSet_gsRoster: 'handleSet_gsRoster',
  handleSet_parentKeyCollectionItems: 'handleSet_parentKeyCollectionItems',
  handleSet_seasonMatchesForBackup: 'handleSet_seasonMatchesForBackup',
  handleSet_sidebar: 'handleSet_sidebar',
  handleSet_sportsInfo: 'handleSet_sportsInfo',
  handleSet_sportsInfoAndResults: 'handleSet_sportsInfoAndResults',
  handleSet_matchDayResults: 'handleSet_matchDayResults',
  handleSet_realtimeResults: 'handleSet_realtimeResults',
  handleSet_sportsMatchesInfo: 'handleSet_sportsMatchesInfo',
  handleSet_sportsResultsInfo: 'handleSet_sportsResultsInfo',
  handleSet_sportsSeasonData: 'handleSet_sportsSeasonData',
  handleSet_sportsSeasonState: 'handleSet_sportsSeasonState',
  handleSet_tempSelectedSeason: 'handleSet_tempSelectedSeason',
  handleShow_sportsElem: 'handleShow_sportsElem',
  handleUpdate_sportsSeasonSubData: 'handleUpdate_sportsSeasonSubData',
  handleUpdate_sportsSeasonTs: 'handleUpdate_sportsSeasonTs',
  ...grts,
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sports season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const sportsSeasonReducer = (state, action) => {

  const {
    appUserAccess,
    currents,
    currentSidebars,
    gameScoringType,
    matches_info,
  } = state

  const { matches } = matches_info ?? {}
  const { type, dispatch } = action


  switch (type) {

    case rts.handleSet_sportsInfoAndResults:
      const { sportsData } = action
      const _newState = ammendState_sportsInfo(sportsData?.sportInfo, state)
      if (sportsData?.sportsResultsInfo?.matchInfo_seasonal) {
        const matches_groupInfo = getMatches_groupInfo(sportsData?.sportsResultsInfo?.matchInfo_seasonal, _newState.selectedSeason, null, appUserAccess)
        const _state_withResults = ammendState_sportsResults(matches_groupInfo, _newState, _getScoresFromScores)
        return _state_withResults
      }
      return state

    case rts.handleSet_sportsInfo:
      const { sportInfo, sportsPageKey } = action
      if (sportInfo) {
        const _state_withInfo = ammendState_sportsInfo(sportInfo, sportsPageKey, state)
        return _state_withInfo
      } else {
        return state
      }

    case rts.handleSet_sportsMatchesInfo:
      const { sportsMatchesInfo } = action
      const { matchInfo_seasonal } = sportsMatchesInfo ?? {}

      // matchInfo_seasonal => matches, playoffMatches...
      if (matchInfo_seasonal) {
        const matches_groupInfo = getMatches_groupInfo(matchInfo_seasonal, state.selectedSeason, null, appUserAccess)
        const _state_withResults = ammendState_sportsResults(matches_groupInfo, state, _getScoresFromScores)
        return _state_withResults
      }
      return { ...state }

    case rts.handleSet_sportsResultsInfo:
      const { sportsResultsInfo } = action
      const { seasonResults } = sportsResultsInfo ?? {}
      // const { matchInfo_seasonal } = sportsResultsInfo ?? {}
      // // matchInfo_seasonal => matches, playoffMatches...
      // if (matchInfo_seasonal) {
      //   const matches_groupInfo = getMatches_groupInfo(matchInfo_seasonal, state.selectedSeason, null, appUserAccess)
      //   const _state_withResults = ammendState_sportsResults(matches_groupInfo, state, _getScoresFromScores)
      //   return _state_withResults
      // }
      return { ...state }

    case rts.handleSet_matchDayResults:
      const { matchDayResults: mdrs } = action
      realTimeScoring.ammendMatchDayResults(mdrs, gameScoringType)
      return { ...state, matchDayResults: mdrs }

    case rts.handleSet_realtimeResults:
      const { realtimeResults } = action
      realTimeScoring.ammendRealtimeResults(realtimeResults, gameScoringType)
      return { ...state, realtimeResults: realtimeResults?.realtimeResults }

    case rts.handleSet_accessTeams:
      return { ...state, access_teams: action.sportsAccess }

    case rts.handleSet_tempSelectedSeason:
      return { ...state, tempSelectedSeason: action.tempSelectedSeason }

    case rts.handleSet_databaseCallback:
      return { ...state, [action.dataType]: action.data }

    case rts.handleAmmend_playoffQualifyCounts:
      return {
        ...state, details_info: {
          ...state.details_info,
          playoffQualifyCounts: action.playoffQualifyCounts
        }
      }

    case rts.handleSet_seasonMatchesForBackup:

      const { data_pure: dp, matches_groupInfo: matches_data_sm, gameScoringType: gameScoringType_sm } = action
      const { data_pure: dpp } = dp ?? {}
      const { matches: matches_dpp } = dpp ?? {}
      const { data: matches_data } = matches_dpp ?? {}
      const { matches: matches_season } = matches_data ?? {}
      const { matchDateGroups: matchDateGroups_sm, dataResult_sm } = matches_data_sm ?? {}
      const { matchDateKeys: matchDateKeys_sm, matchDateKeys_count: matchDateKeys_count_sm } = sportsHelpers.getMatchDateKeys(matchDateGroups_sm)

      matchCalcs.calcAllVballMatches(matches_season, gameScoringType_sm)
      matchCalcs.calcAllVballMatches_displays(matches_season)

      const amm_sm = sportsHelpers.ammendMatchesInfo(matches_season)

      return {
        ...state,
        seasonMatches_info: {
          matchDateGroups: matchDateGroups_sm,
          matchDateKeys_count: matchDateKeys_count_sm,
          matchDateKeys: matchDateKeys_sm,
          matches: amm_sm.matches,
        }
      }

    case rts.handleSet_currentHistory:
      return { ...state, selectedHistory: action.selectedHistory }

    case rts.handleSet_sportsSeasonState:
      const { groupProp, stateProp } = action
      if (groupProp) {
        const _groupProp = state[groupProp] ? state[groupProp] : {}
        _groupProp[stateProp] = action.value
        return { ...state, [groupProp]: _groupProp }
      } else {
        return { ...state, [stateProp]: action.value }
      }

    case rts.handleSet_sportsSeasonData:
      if (action && action.ssData) {
        console.log('action.ssData', action.ssData)
      }
      return { ...state }

    case rts.handleUpdate_sportsSeasonTs:
      return { ...state, timestamp: new Date() }

    case rts.handleUpdate_sportsSeasonSubData:
      return { ...state, [action.subDataType]: action.subData }

    case rts.handleSet_sidebar:
      const crts = { ...currents }
      const crtsbrs = { ...currentSidebars }
      crts[action.clickType] = action.selected
      crtsbrs[action.sbItemType] = action.selected
      return { ...state, currents: crts, currentSidebars: crtsbrs }


    case rts.handleSet_parentKeyCollectionItems:
      const { collectionName, data_sportsCollectionItem } = action.d
      return { ...state, [collectionName]: data_sportsCollectionItem }


    case rts.handleSet_gsRoster:
      if (action.team) {
        return { ...state, ['roster_gs_' + action.team]: action.roster_gs }
      } else {
        return { ...state, roster_gs: action.roster_gs }
      }

    case rts.handleAmmend_mediaMatches:
      return { ...state, matchResultsInfo: action.matchResultsInfo }

    case rts.handleAmmend_teamsAccess:
      const _sportsAccess_sports = state.sportsAccess_teams
      _sportsAccess_sports.teams = action.access_teams
      return { ...state, sportsAccess_teams: _sportsAccess_sports }

    case rts.handleResponse_updateMatch:
      return { ...state, sportsShowType: null }

    case rts.handleShow_sportsElem:
      const { options } = action
      const { sportsShowType } = options ?? {}
      return { ...state, sportsShowType, sportsShowOptions: options }

    case rts.handleAmmend_sportCompares:
      const combined = _.merge({}, state.sportCompares, action.value);
      return { ...state, sportCompares: combined }

    case rts.handleFilter_sports:
      return { ...state, sportFilter: action.sf }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation }, { gsMatchedRefreshed: false })


    default:
      return { ...state }
  }
}

export const sportsSeasonHandlers = (dispatch) => {
  return {
    // handle_testSeason: () => { dispatch({ type: rts.handle_testSeason, dispatch }) },
    handleAmmend_mediaMatches: (matchResultsInfo) => { dispatch({ type: rts.handleAmmend_mediaMatches, dispatch, matchResultsInfo }) },
    handleAmmend_playoffQualifyCounts: (playoffQualifyCounts) => { dispatch({ type: rts.handleAmmend_playoffQualifyCounts, dispatch, playoffQualifyCounts }) },
    // handleAmmend_seasonMatchesFromDbResults: (realtimeDocumentType) => { dispatch({ type: rts.handleAmmend_seasonMatchesFromDbResults, dispatch, realtimeDocumentType }) },
    handleAmmend_sportCompares: (value) => { dispatch({ type: rts.handleAmmend_sportCompares, dispatch, value }) },
    handleAmmend_teamsAccess: (access_teams) => { dispatch({ type: rts.handleAmmend_teamsAccess, dispatch, access_teams }) },
    handleDataResults_parentKeyCollections: (data_pure, sportsSeason_data, matches_groupInfo, parentDataKeys, sportsKey) => { dispatch({ type: rts.handleDataResults_parentKeyCollections, dispatch, data_pure, sportsSeason_data, matches_groupInfo, parentDataKeys, sportsKey }) },
    handleFilter_sports: (sf) => { dispatch({ type: rts.handleFilter_sports, dispatch, sf }) },
    handleResponse_updateMatch: (matchProps) => { dispatch({ type: rts.handleResponse_updateMatch, dispatch, matchProps }) },
    handleSet_accessTeams: (sportsAccess) => { dispatch({ type: rts.handleSet_accessTeams, dispatch, sportsAccess }) },
    handleSet_currentHistory: (selectedHistory) => { dispatch({ type: rts.handleSet_currentHistory, dispatch, selectedHistory }) },
    handleSet_databaseCallback: (data, dataType) => { dispatch({ type: rts.handleSet_databaseCallback, dispatch, data, dataType }) },
    handleSet_gsRoster: (matches_gs, team) => { dispatch({ type: rts.handleSet_gsRoster, dispatch, matches_gs, team }) },
    handleSet_parentKeyCollectionItems: (d) => { dispatch({ type: rts.handleSet_parentKeyCollectionItems, dispatch, d }) },
    handleSet_seasonMatchesForBackup: (data_pure, sportsSeason_data, matches_groupInfo, parentDataKeys, sportsKey) => { dispatch({ type: rts.handleSet_seasonMatchesForBackup, dispatch, data_pure, sportsSeason_data, sportsSeason_data, matches_groupInfo, parentDataKeys, sportsKey }) },
    handleSet_sidebar: (clickType, selected, sidebarType, sbItemType) => { dispatch({ type: rts.handleSet_sidebar, dispatch, clickType, selected, sidebarType, sbItemType }) },
    handleSet_sportsInfo: (sportInfo, sportsPageKey) => { dispatch({ type: rts.handleSet_sportsInfo, dispatch, sportInfo, sportsPageKey }) },
    handleSet_sportsInfoAndResults: (sportsData) => { dispatch({ type: rts.handleSet_sportsInfoAndResults, dispatch, sportsData }) },
    handleSet_sportsMatchesInfo: (sportsMatchesInfo) => { dispatch({ type: rts.handleSet_sportsMatchesInfo, dispatch, sportsMatchesInfo }) },
    handleSet_sportsResultsInfo: (sportsResultsInfo) => { dispatch({ type: rts.handleSet_sportsResultsInfo, dispatch, sportsResultsInfo }) },
    handleSet_matchDayResults: (matchDayResults) => { dispatch({ type: rts.handleSet_matchDayResults, dispatch, matchDayResults }) },
    handleSet_realtimeResults: (realtimeResults) => { dispatch({ type: rts.handleSet_realtimeResults, dispatch, realtimeResults }) },

    handleSet_sportsSeasonData: (ssData) => { dispatch({ type: rts.handleSet_sportsSeasonData, dispatch, ssData }) },
    handleSet_sportsSeasonState: (value, stateProp, groupProp) => { dispatch({ type: rts.handleSet_sportsSeasonState, dispatch, value, stateProp, groupProp }) },
    handleSet_tempSelectedSeason: (tempSelectedSeason) => { dispatch({ type: rts.handleSet_tempSelectedSeason, dispatch, tempSelectedSeason }) },
    handleShow_sportsElem: (options) => { dispatch({ type: rts.handleShow_sportsElem, dispatch, options }) },
    handleUpdate_sportsSeasonSubData: (subDataType, subData) => { dispatch({ type: rts.handleUpdate_sportsSeasonSubData, dispatch }) },
    handleUpdate_sportsSeasonTs: () => { dispatch({ type: rts.handleUpdate_sportsSeasonTs, dispatch }) },
    ...responseHandlers(dispatch),
  }
}

export const sportsSeasonInitialState = (init_state) => {
  return {
    ...init_state,
    currents: {},
    currentSidebars: {},
    _shows_sports: {},
    _validatedTimestamps: {}
  }
};

const ammendSportAccess = (drs) => {
  const { sportsAccess_teams, gls_teams } = drs ?? {}
  const access = {
    ...sportsAccess_teams,
  }
  const settings = {
    ...gls_teams,
  }

  return { access, settings }
}

/**
 * combines the current state with the sportInfo object
 * @param {*} asProps 
 * @returns 
 */
const ammendState_sportsInfo = (sportInfo, sportsPageKey, state) => {

  const _sportInfo = _.cloneDeep(sportInfo)

  // gls_teams 
  // history 
  // mediaFeeds 
  // rankings_seasonal 
  // seasonals 
  // sportsAccess_teams 
  // teamRosters 
  // teams_seasonal 
  // teamStaff 
  // tournaments 

  const {
    gls_teams,
    history,
    mediaFeeds,
    parentDataKeys,
    rankings,
    rssFeeders,
    seasonals,
    sport, // main doc
    sportMode, // derived from page
    sportsAccess_teams,
    teamRosters,
    teams_seasonal,
    teams_sport,
    teamStaff,
    tournaments,
    videoUrls,
  } = _sportInfo ?? {}

  const { latestSeason, id: sportsKey } = sport ?? {}
  const { teams } = teams_seasonal ?? {}

  // ignore teams
  const { details, scheduleDates, sectionDates, crossSectionDates, sportsSettings, playoffQualifyCounts } = seasonals ?? {}

  const _sections = teams ? _.groupBy(teams, 'sections') : null

  const _rankings = rankings ? rankings : null

  const _state_ammended = {
    currentSeason_info: {
      latestSeason: latestSeason,
      latestSeason_full: latestSeason ? (latestSeason - 1) + '-' + latestSeason : latestSeason,
      currentSeason: latestSeason,
      ...sportMode,
      sportsKey,
      parentDataKeys,
    },
    history_info: {
      history: history,
      teams: sportsHelpers.getTeamHistories(teams, history)
    },
    media_info: {
      mediaFeeds,
      rssFeeders,
    },
    video_info: {
      videoUrls,
    },
    teams_info: {
      teams: teams,
      teams_sport: teams_sport?.teams,
      rosters: teamRosters,
      staff: teamStaff,
      playoffTeams: teams && sportsHelpers.getPlayoffTeams(teams),
      sectionKeys: _sections ? Object.keys(_sections).sort() : [],
    },
    roster_info: {
      rosters: teamRosters,
      staff: teamStaff,
    },
    tournaments_info: {
      tournaments: tournaments,
    },
    rankings_info: {
      rankings: _rankings,
      lastestRanking: sportsHelpers.getLastestRankings(_rankings)
    },
    seasonal_info: {
      scheduleDates,
      sectionDates,
      crossSectionDates,
      seasonReady: true,
      sportsSettings,
    },
    details_info: {
      details: details,
      sectionPlayoffTeams: playoffQualifyCounts || {
        4: 2,
        5: 4,
        6: 4,
        7: 4,
        8: 4,
        9: 4,
      },
      playoffQualifyCounts: playoffQualifyCounts || {
        4: 2,
        5: 4,
        6: 4,
        7: 4,
        8: 4,
        9: 4,
      }
    },
    googleLinks_info: {
      gls_teams: gls_teams
    },
    sportsAccess_teams: {
      teams: sportsAccess_teams ? { ...sportsAccess_teams.teams } : {},
    },
    gls_teams: gls_teams ? { ...gls_teams } : {},
    sportsSeason_datas: _sportInfo,
    sportsPageKey
  }

  const newState = _.merge({}, state, _state_ammended);

  return newState
}

/**
 * combines the existing state with matches_info
 * @param {object} asProps 
 * @returns 
 */
const ammendState_sportsResults = (matches_groupInfo, state, _getScoresFromScores) => {

  const { currentSeason_info, teams_info, _sportSeasonSettings, details_info } = state ?? {}
  const { gameScoringType, _sportsModeSport } = currentSeason_info ?? {}
  const { teams: teams_seasonal } = teams_info ?? {}
  const { playoffQualifyCounts, sectionPlayoffTeams } = details_info ?? {}
  const { startHour } = _sportSeasonSettings ?? {}

  const {
    levelLatestStartDates,
    selectedSeason: _selectedSeason,
    playoffTournaments,
  } = matches_groupInfo ?? {}

  const { matches_info, _teamsFromMatches, upcomingMatchDate, amm, ssi } = ammendMatchesAndTeams(
    matches_groupInfo,
    teams_seasonal,
    teams_info,
    gameScoringType,
    _getScoresFromScores,
    levelLatestStartDates,
    startHour,
    _sportsModeSport,
    null,
    playoffQualifyCounts,
    sectionPlayoffTeams,
  )

  const playoff_info = {
    playoffTournaments: playoffTournaments ? playoffTournaments : null,
  }

  const _matches_state = {
    playoff_info,
    seasonal_info: {
      sportLevels: ssi?.sportLevels,
      totalWeeks: amm?.totalWeeks,
      firstMatchDate: amm?.firstMatchDate,
      lastMatchDate: amm?.lastMatchDate,
    },
    upcomingMatchDate,
    matches_info
  }

  const newState = {
    ...state,
    ..._matches_state,
    // teams_info: {
    //   ...teams_info,
    //   teams: ssi?.teams,
    // }
  }

  return newState
}

const switchTeams = ({
  teams,
  matches,
  teamKey1,
  teamKey2,
}) => {
  const team1 = _.find(teams, {
    _itemKey: teamKey1,
  });

  const team2 = _.find(teams, {
    _itemKey: teamKey2,
  });

  if (!team1 || !team2) {
    throw new Error('Both teams must exist');
  }

  const updates = {};

  /*
   * TEAM UPDATES
   *
   * Keep each team's _itemKey.
   * Copy the scheduling/section data from the other team.
   */
  updates[`teams.${teamKey1}`] = {
    ...team2,
    _itemKey: teamKey1,
  };

  updates[`teams.${teamKey2}`] = {
    ...team1,
    _itemKey: teamKey2,
  };


  /*
   * MATCH UPDATES
   */
  _.forEach(matches, (match, matchKey) => {

    const update = {};

    if (match?.home?._itemKey === teamKey1) {
      update.home = {
        ...team2,
        _itemKey: teamKey1,
      };
    }

    if (match?.home?._itemKey === teamKey2) {
      update.home = {
        ...team1,
        _itemKey: teamKey2,
      };
    }

    if (match?.away?._itemKey === teamKey1) {
      update.away = {
        ...team2,
        _itemKey: teamKey1,
      };
    }

    if (match?.away?._itemKey === teamKey2) {
      update.away = {
        ...team1,
        _itemKey: teamKey2,
      };
    }

    if (update.home) {
      updates[`matches.${matchKey}.home`] = update.home;
    }

    if (update.away) {
      updates[`matches.${matchKey}.away`] = update.away;
    }

  });

  return updates;
};